/** One labelled input on the staff edit form, in whichever shape its type asks
 *  for — a textarea, or an input of the matching kind. */
interface EditableFieldProps {
  label: string;
  value: string | number | null | undefined;
  onChange: (next: string) => void;
  type?: 'text' | 'email' | 'tel' | 'date' | 'textarea';
  placeholder?: string;
  error?: string;
}

export default function StaffEditableField({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  error,
}: EditableFieldProps) {
  const stringValue = value === null || value === undefined ? '' : String(value);
  const inputClassName = `w-full px-2.5 py-1.5 text-sm rounded-md border ${
    error
      ? 'border-red-400 dark:border-red-500 focus:ring-red-400'
      : 'border-stone-300 dark:border-stone-700 focus:ring-moss-500'
  } bg-white dark:bg-[#0f1411] text-bark-900 dark:text-stone-100 placeholder-stone-400 focus:outline-none focus:ring-2`;
  return (
    <div>
      <p className="block text-xs text-stone-500 dark:text-stone-400 mb-1">{label}</p>
      {type === 'textarea' ? (
        <textarea
          className={inputClassName}
          rows={3}
          aria-label={label}
          value={stringValue}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          className={inputClassName}
          type={type}
          aria-label={label}
          value={stringValue}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
      {error && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{error}</p>}
    </div>
  );
}
